/* eslint-disable @typescript-eslint/no-explicit-any */
import { Loader } from "@mantine/core";
import * as AlertDialog from "@radix-ui/react-alert-dialog";
import { Dispatch, SetStateAction } from "react";

interface Props {
  opened: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  title: string;
  description: string;
  cancelText?: string;
  acceptText?: string;
  onClick: any;
  loading?: boolean;
}

const WarningDialog = ({
  opened,
  setOpen,
  title,
  description,
  cancelText,
  acceptText,
  onClick,
  loading,
}: Props) => (
  <AlertDialog.Root open={opened}>
    <AlertDialog.Portal>
      <AlertDialog.Overlay className="bg-blackA9 data-[state=open]:animate-overlayShow fixed inset-0 z-30" />
      <AlertDialog.Content className="data-[state=open]:animate-contentShow z-[100] fixed top-[50%] left-[50%] max-h-[85vh] w-[90vw] max-w-[500px] translate-x-[-50%] translate-y-[-50%] rounded-[6px] bg-white p-[25px] shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none">
        <AlertDialog.Title className="text-mauve12 m-0 text-[17px] font-medium">
          {title}
        </AlertDialog.Title>
        <AlertDialog.Description className="text-mauve11 mt-4 mb-5 text-[15px] leading-normal">
          {description}
        </AlertDialog.Description>
        <div className="flex justify-end gap-[25px]">
          <AlertDialog.Cancel asChild>
            <button
              onClick={() => setOpen(false)}
              className="text-mauve11 bg-mauve4 hover:bg-mauve5 focus:shadow-mauve7 inline-flex h-[35px] items-center justify-center rounded-[4px] px-[15px] font-medium leading-none outline-none focus:shadow-[0_0_0_2px]"
            >
              {cancelText ? cancelText : "Cancel"}
            </button>
          </AlertDialog.Cancel>
          <AlertDialog.Action asChild>
            <button
              onClick={onClick ? onClick : () => null}
              className="text-red11 bg-red4 hover:bg-red5 focus:shadow-red7 inline-flex h-[35px] items-center justify-center rounded-[4px] px-[15px] font-medium leading-none outline-none focus:shadow-[0_0_0_2px]"
            >
              {acceptText ? acceptText : "Confirm"}
              {loading && (
                <div className="flex w-full items-center justify-center">
                  {/* <Spinner /> */}
                  <Loader color="red" size="sm" />
                </div>
              )}
            </button>
          </AlertDialog.Action>
        </div>
      </AlertDialog.Content>
    </AlertDialog.Portal>
  </AlertDialog.Root>
);

export default WarningDialog;
